export function validateBillingPlanPatcher(data) {
    return {
        __typename: 'ValidateBillingPlanMutation',
        ...data,
        validateBillingPlan: {
            __typename: 'ValidateBillingPlan',
            ...data.validateBillingPlan,
        },
    };
}
